export const getInvitationsData = state => state.invitations.all;
export const getInvitationData = state => state.invitations.invitation;
export const invitationsIsFetching = state => state.invitations.loading.all;
export const invitationIsFetching = state => state.invitations.loading.invitation;